import { useLingui } from '@lingui/react/macro';

import { UniqueArticleSearchSelect } from '@/components/UniqueArticleSearchSelect';
import { useUpdateArticleExchange } from '@/models/articleExchange';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

export const ReplacementUniqueArticle = () => {
  const { view, article, errors } = useArticleContext();
  const { t } = useLingui();

  const { mutate: updateArticleExchange } = useUpdateArticleExchange(article.id);

  return (
    <UniqueArticleSearchSelect
      labelProps={{
        label: t({
          id: 'service-choice.exchange.unique-article.label',
          message: 'Replacement item serial number',
        }),
        optional:
          view.services.exchange.replacementUniqueArticle.editable &&
          !view.services.exchange.replacementUniqueArticle.required,
      }}
      ariaLabel={t({
        id: 'service-choice.exchange.unique-article.label',
        message: 'Replacement item serial number',
      })}
      value={article.snapshot?.articleExchange?.replacementUniqueArticle ?? null}
      onChange={(uniqueArticle) =>
        updateArticleExchange({ replacementUniqueArticleId: uniqueArticle?.id || null })
      }
      placeholder={t({
        id: 'service-choice.exchange.unique-article.placeholder',
        message: "Add the replacement item's serial number...",
      })}
      isReplacementSerialNumber
      productId={article.snapshot?.articleExchange?.replacementProductId ?? undefined}
      error={
        errors.services?.exchange?.missingReplacementUniqueArticle
          ? t({
              id: 'replacement-unique-article.errors.missing',
              message: 'Please add a valid replacement item serial number',
            })
          : undefined
      }
    />
  );
};
